export default __webpack_public_path__ + "img/rule_5-aa971c2d.png";